import * as React from "react";
import {Box, Button, Paper, Typography, useTheme} from "@mui/material";
import globalStyles, {globalColors} from "../../styles/globalStyles";
import useNavigationHelper from "../NavigationHelper";


const InvestAd = () => {
  const {navigateInvest} = useNavigationHelper()

  const theme = useTheme()

  const styles = {
    paper : {
      display: "flex",
      flexDirection: "row",
      flexGrow: 1,
      justifyContent: "stretch",
      alignItems: "center",
      backgroundColor: theme.palette.background.paper,
      marginTop: theme.spacing(0.5),
      marginRight: theme.spacing(2),
      padding: theme.spacing(0),
      // paddingLeft: 0
    },
    title: {
      color: globalColors.webFlowButton,
      marginBottom: theme.spacing(1),
      textTransform: "uppercase"
    },
    subtitle: {
      color: theme.palette.primary.main,
      // marginBottom: theme.spacing(2)
    },
  }

  return (
    <Paper elevation={0} sx={styles.paper}>
      <Box display="flex" flexGrow={1}>
        <Typography variant="h5" sx={styles.subtitle}>
          Grow your wealth and<br/>
          secure your future!
        </Typography>
      </Box>
      <Box display="flex" flexGrow={0}>
        <Button variant="contained" size="medium" color="primary" sx={{...globalStyles.webFlowButton, height:30, width:100, fontWeight:700}}
                type="button" onClick={() => navigateInvest()}>
          Invest
        </Button>
      </Box>
    </Paper>
  )
}

export default InvestAd